import { toast } from "react-toastify"
import { API_URL } from "../../lib/const"
import { decodeBase64, encodeBase64 } from "../../lib/utils"
import axios from "axios"

export const generateVacanciesOnboardingReport = ( data ) => {
  toast.info( "Gerando Relatório" )
  return axios
    .post( `${API_URL}/reports/registered_vacancies_report`, data, {
      responseType: "blob",
    } )
    .then( ( response ) => {
      const file = new Blob( [response.data], { type: "application/pdf" } )
      const fileURL = URL.createObjectURL( file )
      const pdfWindow = window.open()

      if ( pdfWindow ) {
        pdfWindow.document.write( `
                    <html>
                      <head><title>Relatório</title></head>
                      <body style="margin:0">
                        <embed width="100%" height="100%" src="${fileURL}" type="application/pdf">
                      </body>
                    </html>
                `)
        pdfWindow.document.title = "Relatório"
      } else {
        alert(
          "Não foi possível abrir o PDF. Verifique se os pop-ups estão bloqueados."
        )
      }

      toast.dismiss()
    } )
    .catch( ( e ) => {
      toast.error( "Ocorreu um erro inesperado, tente novamente mais tarde" )
      return Promise.reject( e )
    } )
}

export const getReportData = () => {
  return axios
    .get( `${API_URL}/reports/registered_vacancies_report` )
    .then( ( response ) => response.data )
}
export const getSQLReportData = (page = 1) => {
  return axios
    .get(`${API_URL}/reports/sql_reports/`, {
      params: { page }
    })
    .then((response) => response.data);
};
export const getSQLReportDetail = ( id ) => {
  return axios
    .get( `${API_URL}/reports/sql_reports/${id}/`, )
    .then( ( response ) => { return { ...response.data, sql: decodeBase64( response.data.sql ) } } )
    .catch( ( err ) => {
      return toast.error( 'Relatório com o ID informado não encontrado' )
    } )
}
export const getSQLReportView = ( id, params ) => {

  return axios
    .get( `${API_URL}/reports/sql_reports/data/?report=${id}&page=${params.page}&page_size=${params.page_size}`)
    .then( ( response ) => { return { ...response.data } } )
    .catch( ( err ) => {
      return toast.error( 'Relatório com o ID informado não encontrado' )
    } )
}
export const createSQLReportData = ( data ) => {
  return axios
    .post( `${API_URL}/reports/sql_reports/`, { ...data, sql: encodeBase64( data.sql ) } )
    .then( ( response ) => response.data )
}
export const updateSQLReportData = ( id, data ) => {
  return axios
    .patch( `${API_URL}/reports/sql_reports/${id}/`, { ...data, sql: encodeBase64( data.sql ) } )
    .then( ( response ) => response.data )
}
export const deleteSQLReportData = ( id ) => {
  return axios
    .delete( `${API_URL}/reports/sql_reports/${id}/` )
    .then( ( response ) => response.data )
}
